import React, { useState } from 'react'
import GenericButton from '../../GenericButton'
import GenericModal from '../../GenericModal'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import DefaultModalActions from '../../GenericModal/DefaultModalActions'
import { blue, grey } from '../../../colors'
import SearchIcon from '@mui/icons-material/Search'
import EditIcon from '@mui/icons-material/Edit'
import AddIcon from '@mui/icons-material/Add'
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined'
import { Grid, Typography } from '@mui/material'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import FilterListIcon from '@mui/icons-material/FilterList'
import GetAppIcon from '@mui/icons-material/GetApp'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Pagination from '@mui/icons-material/FirstPage'
import SortByAlphaOutlinedIcon from '@mui/icons-material/SortByAlphaOutlined'
interface Instruction {
  icon: React.ReactNode
  label: string
}

const TableInstruction: React.FC<Instruction> = ({ icon, label }) => {
  const [boldText, regularText] = label.split(':')

  return (
    <Grid item xs={12} display={'flex'} gap={2.5} mt={1} >
        {icon}{' '}
      <Typography variant="body1" lineHeight={1.5} >
        <strong>{boldText}:</strong> {regularText.trim()}
      </Typography>
    </Grid>
  )
}

const instructions: Instruction[] = [
  {
    icon: <SearchIcon />,
    label: 'Search: Type in the search bar and press Enter or click outside the table to trigger a search.'
  },
  {
    icon: <SortByAlphaOutlinedIcon />,
    label: 'Sorting: Click on a column header to sort the table in ascending or descending order.'
  },

  {
    icon: <AddIcon />,
    label: 'Create New Data: Click the Create button to add new entries to the table.'
  },
  {
    icon: <GetAppIcon />,
    label: 'Export to CSV: Click this button to download the table data as a CSV file.'
  },
  {
    icon: <EditIcon />,
    label: 'Edit Data: Double-click any row or click the Edit button to modify existing data.'
  },
  {
    icon: <MoreVertIcon />,
    label: 'Actions: Click the three dots on the right of a row to open the actions menu, where you can delete or archive a row.'
  },
  {
    icon: <Pagination />,
    label: 'Pagination: Use the pagination controls at the bottom of the table to navigate between pages of data.'
  },
  {
    icon: <AspectRatioOutlinedIcon />,
    label: 'Resize Column: Hover over the right edge of a column header to see the resize handle. Drag it to adjust the column width.'
  }
]

const TableGuidelines: React.FC = (): JSX.Element => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  const handleOpen = (): void => {
    setOpenModal(true)
  }

  const handleClose = (): void => {
    setOpenModal(false)
  }

  return (
    <>
      <GenericButton onClick={handleOpen} style={{ paddingLeft: 4 }} icon={<InfoOutlinedIcon sx={{ color: grey[400], width: '18px', height: '18px', mt: 0.5 }} />} />
      <GenericModal maxWidth='md' title='How to use Table' isOpen={openModal} onClose={handleClose} action={false}>
        <Grid container spacing={2} mt={2}>
          {instructions.map((instruction, index) => (
            <TableInstruction key={index} icon={instruction.icon} label={instruction.label} />
          ))}
        </Grid>
        <DefaultModalActions
          destructiveButtonProps={{
            onClick: handleClose
          }}
          confirmButtonProps={{
            hideButton: true
          }}

        />
      </GenericModal>
    </>
  )
}

export default TableGuidelines
